import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const blogArticles = [
  {
    slug: 'reparation-fenetre-bordeaux-guide-complet',
    city: 'Bordeaux',
    title: 'Réparation de Fenêtres à Bordeaux : Guide Complet 2025',
    excerpt: 'Découvrez tout ce qu\'il faut savoir sur la réparation de fenêtres PVC, bois, aluminium, baies vitrées et volets roulants à Bordeaux.',
    image: 'https://public.readdy.ai/ai/img_res/d8fa487696beae3cb8d57fe8e413feb0.jpg',
    date: '15 Janvier 2025',
    readTime: '12 min',
    category: 'Guide Complet'
  },
  {
    slug: 'reparation-fenetre-merignac-expert',
    city: 'Mérignac',
    title: 'Expert en Réparation de Fenêtres à Mérignac',
    excerpt: 'Votre spécialiste de la réparation de fenêtres PVC, bois, aluminium et baies vitrées à Mérignac. Intervention rapide et garantie.',
    image: 'https://readdy.ai/api/search-image?query=modern%20aluminum%20window%20repair%20in%20contemporary%20Merignac%20home%2C%20professional%20technician%20adjusting%20mechanism%2C%20bright%20interior%20with%20natural%20light%2C%20clean%20workspace&width=800&height=500&seq=blog2&orientation=landscape',
    date: '14 Janvier 2025',
    readTime: '10 min',
    category: 'Expertise Locale'
  },
  {
    slug: 'reparation-fenetre-pessac-professionnel',
    city: 'Pessac',
    title: 'Réparation de Fenêtres à Pessac : Service Professionnel',
    excerpt: 'Dépannage et réparation de fenêtres, baies vitrées et volets roulants à Pessac. Devis gratuit et intervention sous 24h.',
    image: 'https://readdy.ai/api/search-image?query=wooden%20window%20frame%20repair%20in%20charming%20Pessac%20residence%2C%20craftsman%20working%20with%20precision%20tools%2C%20warm%20natural%20wood%20tones%2C%20professional%20restoration%20work&width=800&height=500&seq=blog3&orientation=landscape',
    date: '13 Janvier 2025',
    readTime: '11 min',
    category: 'Service Pro'
  },
  {
    slug: 'reparation-fenetre-talence-specialiste',
    city: 'Talence',
    title: 'Spécialiste Réparation de Fenêtres à Talence',
    excerpt: 'Réparation experte de fenêtres PVC, bois, aluminium et volets roulants à Talence. Plus de 15 ans d\'expérience.',
    image: 'https://readdy.ai/api/search-image?query=sliding%20bay%20window%20repair%20in%20modern%20Talence%20home%2C%20technician%20replacing%20rollers%20and%20tracks%2C%20spacious%20bright%20interior%2C%20professional%20service&width=800&height=500&seq=blog4&orientation=landscape',
    date: '12 Janvier 2025',
    readTime: '10 min',
    category: 'Spécialiste'
  },
  {
    slug: 'reparation-fenetre-villenave-ornon',
    city: 'Villenave-d\'Ornon',
    title: 'Réparation de Fenêtres à Villenave-d\'Ornon',
    excerpt: 'Service de réparation de fenêtres et baies vitrées à Villenave-d\'Ornon. Intervention rapide et tarifs transparents.',
    image: 'https://readdy.ai/api/search-image?query=PVC%20window%20seal%20replacement%20in%20Villenave%20d%20Ornon%20apartment%2C%20close%20up%20of%20professional%20installation%2C%20detailed%20work%2C%20quality%20materials&width=800&height=500&seq=blog5&orientation=landscape',
    date: '11 Janvier 2025',
    readTime: '9 min',
    category: 'Service Local'
  },
  {
    slug: 'reparation-fenetre-begles-expert',
    city: 'Bègles',
    title: 'Expert Réparation de Fenêtres à Bègles',
    excerpt: 'Réparation professionnelle de fenêtres, volets roulants et baies vitrées à Bègles. Devis gratuit en ligne.',
    image: 'https://readdy.ai/api/search-image?query=electric%20roller%20shutter%20repair%20in%20Begles%20home%2C%20technician%20working%20on%20motor%20mechanism%2C%20modern%20interior%2C%20professional%20equipment&width=800&height=500&seq=blog6&orientation=landscape',
    date: '10 Janvier 2025',
    readTime: '10 min',
    category: 'Expertise'
  },
  {
    slug: 'reparation-fenetre-cenon-professionnel',
    city: 'Cenon',
    title: 'Réparation de Fenêtres à Cenon : Service Pro',
    excerpt: 'Dépannage de fenêtres PVC, bois, aluminium et volets roulants à Cenon. Intervention sous 24h garantie.',
    image: 'https://readdy.ai/api/search-image?query=broken%20window%20glass%20replacement%20in%20Cenon%20residence%2C%20professional%20glazier%20installing%20new%20double%20glazing%2C%20safety%20equipment%2C%20precise%20work&width=800&height=500&seq=blog7&orientation=landscape',
    date: '9 Janvier 2025',
    readTime: '11 min',
    category: 'Pro Service'
  },
  {
    slug: 'reparation-fenetre-gradignan-specialiste',
    city: 'Gradignan',
    title: 'Spécialiste Fenêtres à Gradignan',
    excerpt: 'Réparation et entretien de fenêtres à Gradignan. Expertise en PVC, bois, aluminium et baies vitrées.',
    image: 'https://readdy.ai/api/search-image?query=aluminum%20bay%20window%20adjustment%20in%20elegant%20Gradignan%20villa%2C%20technician%20using%20precision%20tools%2C%20luxury%20interior%2C%20professional%20service&width=800&height=500&seq=blog8&orientation=landscape',
    date: '8 Janvier 2025',
    readTime: '10 min',
    category: 'Spécialiste'
  },
  {
    slug: 'reparation-fenetre-eysines',
    city: 'Eysines',
    title: 'Réparation de Fenêtres à Eysines',
    excerpt: 'Service complet de réparation de fenêtres et volets roulants à Eysines. Devis gratuit et rapide.',
    image: 'https://readdy.ai/api/search-image?query=wooden%20window%20restoration%20in%20traditional%20Eysines%20house%2C%20craftsman%20applying%20treatment%2C%20natural%20wood%20beauty%2C%20artisan%20work&width=800&height=500&seq=blog9&orientation=landscape',
    date: '7 Janvier 2025',
    readTime: '9 min',
    category: 'Service Complet'
  },
  {
    slug: 'reparation-fenetre-le-bouscat',
    city: 'Le Bouscat',
    title: 'Réparation de Fenêtres au Bouscat',
    excerpt: 'Expert en réparation de fenêtres PVC, bois, aluminium au Bouscat. Intervention rapide et professionnelle.',
    image: 'https://readdy.ai/api/search-image?query=modern%20PVC%20window%20mechanism%20repair%20in%20Le%20Bouscat%20apartment%2C%20technician%20adjusting%20hinges%2C%20contemporary%20interior%2C%20professional%20tools&width=800&height=500&seq=blog10&orientation=landscape',
    date: '6 Janvier 2025',
    readTime: '10 min',
    category: 'Expert Local'
  },
  {
    slug: 'reparation-fenetre-bruges',
    city: 'Bruges',
    title: 'Réparation de Fenêtres à Bruges',
    excerpt: 'Dépannage de fenêtres et baies vitrées à Bruges. Service professionnel et tarifs compétitifs.',
    image: 'https://readdy.ai/api/search-image?query=sliding%20door%20repair%20in%20modern%20Bruges%20home%2C%20professional%20fixing%20track%20system%2C%20bright%20spacious%20room%2C%20quality%20service&width=800&height=500&seq=blog11&orientation=landscape',
    date: '5 Janvier 2025',
    readTime: '9 min',
    category: 'Dépannage'
  },
  {
    slug: 'reparation-fenetre-floirac',
    city: 'Floirac',
    title: 'Réparation de Fenêtres à Floirac',
    excerpt: 'Spécialiste de la réparation de fenêtres et volets roulants à Floirac. Devis gratuit en ligne.',
    image: 'https://readdy.ai/api/search-image?query=window%20lock%20repair%20in%20Floirac%20residence%2C%20close%20up%20of%20security%20mechanism%20installation%2C%20professional%20hands%20working%2C%20detailed%20craftsmanship&width=800&height=500&seq=blog12&orientation=landscape',
    date: '4 Janvier 2025',
    readTime: '10 min',
    category: 'Spécialiste'
  },
  {
    slug: 'reparation-fenetre-lormont',
    city: 'Lormont',
    title: 'Réparation de Fenêtres à Lormont',
    excerpt: 'Service de réparation de fenêtres PVC, bois, aluminium à Lormont. Intervention sous 24h.',
    image: 'https://readdy.ai/api/search-image?query=bay%20window%20weatherstripping%20replacement%20in%20Lormont%20apartment%2C%20technician%20installing%20new%20seals%2C%20energy%20efficiency%20improvement%2C%20professional%20work&width=800&height=500&seq=blog13&orientation=landscape',
    date: '3 Janvier 2025',
    readTime: '11 min',
    category: 'Service Rapide'
  },
  {
    slug: 'reparation-fenetre-blanquefort',
    city: 'Blanquefort',
    title: 'Réparation de Fenêtres à Blanquefort',
    excerpt: 'Expert en réparation de fenêtres et baies vitrées à Blanquefort. Plus de 15 ans d\'expérience.',
    image: 'https://readdy.ai/api/search-image?query=aluminum%20window%20frame%20repair%20in%20Blanquefort%20villa%2C%20professional%20using%20specialized%20tools%2C%20modern%20architecture%2C%20quality%20restoration&width=800&height=500&seq=blog14&orientation=landscape',
    date: '2 Janvier 2025',
    readTime: '10 min',
    category: 'Expert'
  },
  {
    slug: 'reparation-fenetre-le-haillan',
    city: 'Le Haillan',
    title: 'Réparation de Fenêtres au Haillan',
    excerpt: 'Réparation professionnelle de fenêtres et volets roulants au Haillan. Devis gratuit.',
    image: 'https://readdy.ai/api/search-image?query=roller%20shutter%20blade%20replacement%20in%20Le%20Haillan%20house%2C%20technician%20working%20on%20exterior%2C%20residential%20area%2C%20professional%20service&width=800&height=500&seq=blog15&orientation=landscape',
    date: '1 Janvier 2025',
    readTime: '9 min',
    category: 'Pro'
  },
  {
    slug: 'reparation-fenetre-parempuyre',
    city: 'Parempuyre',
    title: 'Réparation de Fenêtres à Parempuyre',
    excerpt: 'Service complet de réparation de fenêtres à Parempuyre. Intervention rapide et garantie.',
    image: 'https://readdy.ai/api/search-image?query=PVC%20window%20hinge%20adjustment%20in%20Parempuyre%20home%2C%20technician%20using%20precision%20tools%2C%20clean%20interior%2C%20professional%20maintenance&width=800&height=500&seq=blog16&orientation=landscape',
    date: '31 Décembre 2024',
    readTime: '10 min',
    category: 'Service Complet'
  },
  {
    slug: 'reparation-fenetre-carbon-blanc',
    city: 'Carbon-Blanc',
    title: 'Réparation de Fenêtres à Carbon-Blanc',
    excerpt: 'Spécialiste réparation de fenêtres PVC, bois, aluminium à Carbon-Blanc. Tarifs transparents.',
    image: 'https://readdy.ai/api/search-image?query=wooden%20window%20sash%20repair%20in%20Carbon%20Blanc%20residence%2C%20craftsman%20restoring%20traditional%20window%2C%20natural%20materials%2C%20artisan%20expertise&width=800&height=500&seq=blog17&orientation=landscape',
    date: '30 Décembre 2024',
    readTime: '11 min',
    category: 'Spécialiste'
  },
  {
    slug: 'reparation-fenetre-artigues-bordeaux',
    city: 'Artigues-près-Bordeaux',
    title: 'Réparation de Fenêtres à Artigues-près-Bordeaux',
    excerpt: 'Dépannage de fenêtres et baies vitrées à Artigues-près-Bordeaux. Service professionnel.',
    image: 'https://readdy.ai/api/search-image?query=modern%20bay%20window%20repair%20in%20Artigues%20pres%20Bordeaux%20apartment%2C%20technician%20working%20on%20sliding%20mechanism%2C%20contemporary%20design%2C%20professional%20service&width=800&height=500&seq=blog18&orientation=landscape',
    date: '29 Décembre 2024',
    readTime: '10 min',
    category: 'Dépannage'
  },
  {
    slug: 'reparation-fenetre-ambares-lagrave',
    city: 'Ambarès-et-Lagrave',
    title: 'Réparation de Fenêtres à Ambarès-et-Lagrave',
    excerpt: 'Expert en réparation de fenêtres et volets roulants à Ambarès-et-Lagrave. Devis gratuit.',
    image: 'https://readdy.ai/api/search-image?query=electric%20roller%20shutter%20motor%20replacement%20in%20Ambares%20et%20Lagrave%20home%2C%20technician%20installing%20new%20motor%2C%20modern%20automation%2C%20professional%20installation&width=800&height=500&seq=blog19&orientation=landscape',
    date: '28 Décembre 2024',
    readTime: '9 min',
    category: 'Expert'
  },
  {
    slug: 'reparation-fenetre-cestas',
    city: 'Cestas',
    title: 'Réparation de Fenêtres à Cestas',
    excerpt: 'Service de réparation de fenêtres PVC, bois, aluminium à Cestas. Intervention sous 24h.',
    image: 'https://readdy.ai/api/search-image?query=aluminum%20window%20glass%20replacement%20in%20Cestas%20villa%2C%20professional%20glazier%20working%20carefully%2C%20modern%20architecture%2C%20safety%20procedures&width=800&height=500&seq=blog20&orientation=landscape',
    date: '27 Décembre 2024',
    readTime: '10 min',
    category: 'Service'
  },
  {
    slug: 'reparation-fenetre-saint-medard-jalles',
    city: 'Saint-Médard-en-Jalles',
    title: 'Réparation de Fenêtres à Saint-Médard-en-Jalles',
    excerpt: 'Réparation professionnelle de fenêtres à Saint-Médard-en-Jalles. Expertise et rapidité.',
    image: 'https://readdy.ai/api/search-image?query=PVC%20window%20seal%20and%20insulation%20repair%20in%20Saint%20Medard%20en%20Jalles%20house%2C%20technician%20improving%20energy%20efficiency%2C%20modern%20tools%2C%20professional%20work&width=800&height=500&seq=blog21&orientation=landscape',
    date: '26 Décembre 2024',
    readTime: '11 min',
    category: 'Pro'
  },
  {
    slug: 'reparation-fenetre-libourne',
    city: 'Libourne',
    title: 'Réparation de Fenêtres à Libourne',
    excerpt: 'Spécialiste de la réparation de fenêtres et baies vitrées à Libourne. Devis gratuit.',
    image: 'https://readdy.ai/api/search-image?query=traditional%20wooden%20window%20restoration%20in%20historic%20Libourne%20building%2C%20craftsman%20preserving%20heritage%2C%20classic%20architecture%2C%20expert%20restoration&width=800&height=500&seq=blog22&orientation=landscape',
    date: '25 Décembre 2024',
    readTime: '10 min',
    category: 'Spécialiste'
  },
  {
    slug: 'reparation-fenetre-saint-andre-cubzac',
    city: 'Saint-André-de-Cubzac',
    title: 'Réparation de Fenêtres à Saint-André-de-Cubzac',
    excerpt: 'Expert en réparation de fenêtres PVC, bois, aluminium à Saint-André-de-Cubzac.',
    image: 'https://readdy.ai/api/search-image?query=bay%20window%20track%20repair%20in%20Saint%20Andre%20de%20Cubzac%20residence%2C%20technician%20cleaning%20and%20lubricating%20mechanism%2C%20maintenance%20work%2C%20professional%20service&width=800&height=500&seq=blog23&orientation=landscape',
    date: '24 Décembre 2024',
    readTime: '9 min',
    category: 'Expert'
  },
  {
    slug: 'reparation-fenetre-arcachon',
    city: 'Arcachon',
    title: 'Réparation de Fenêtres à Arcachon',
    excerpt: 'Service de réparation de fenêtres et volets roulants à Arcachon. Intervention rapide.',
    image: 'https://readdy.ai/api/search-image?query=coastal%20window%20repair%20in%20Arcachon%20beach%20house%2C%20technician%20working%20on%20salt%20resistant%20windows%2C%20ocean%20view%2C%20specialized%20maintenance&width=800&height=500&seq=blog24&orientation=landscape',
    date: '23 Décembre 2024',
    readTime: '10 min',
    category: 'Service'
  },
  {
    slug: 'reparation-fenetre-la-teste-buch',
    city: 'La Teste-de-Buch',
    title: 'Réparation de Fenêtres à La Teste-de-Buch',
    excerpt: 'Réparation professionnelle de fenêtres à La Teste-de-Buch. Devis gratuit en ligne.',
    image: 'https://readdy.ai/api/search-image?query=modern%20window%20mechanism%20repair%20in%20La%20Teste%20de%20Buch%20home%2C%20professional%20technician%20adjusting%20opening%20system%2C%20bright%20interior%2C%20quality%20service&width=800&height=500&seq=blog25&orientation=landscape',
    date: '22 Décembre 2024',
    readTime: '11 min',
    category: 'Pro'
  },
  {
    slug: 'reparation-fenetre-gujan-mestras',
    city: 'Gujan-Mestras',
    title: 'Réparation de Fenêtres à Gujan-Mestras',
    excerpt: 'Spécialiste réparation de fenêtres et baies vitrées à Gujan-Mestras. Service rapide.',
    image: 'https://readdy.ai/api/search-image?query=sliding%20bay%20window%20roller%20replacement%20in%20Gujan%20Mestras%20villa%2C%20technician%20installing%20new%20wheels%2C%20smooth%20operation%2C%20professional%20repair&width=800&height=500&seq=blog26&orientation=landscape',
    date: '21 Décembre 2024',
    readTime: '10 min',
    category: 'Spécialiste'
  },
  {
    slug: 'reparation-fenetre-andernos-bains',
    city: 'Andernos-les-Bains',
    title: 'Réparation de Fenêtres à Andernos-les-Bains',
    excerpt: 'Expert en réparation de fenêtres PVC, bois, aluminium à Andernos-les-Bains.',
    image: 'https://readdy.ai/api/search-image?query=window%20weatherproofing%20in%20Andernos%20les%20Bains%20coastal%20home%2C%20technician%20applying%20marine%20grade%20sealant%2C%20ocean%20environment%20protection%2C%20specialized%20work&width=800&height=500&seq=blog27&orientation=landscape',
    date: '20 Décembre 2024',
    readTime: '9 min',
    category: 'Expert'
  },
  {
    slug: 'reparation-fenetre-biganos',
    city: 'Biganos',
    title: 'Réparation de Fenêtres à Biganos',
    excerpt: 'Service complet de réparation de fenêtres et volets roulants à Biganos.',
    image: 'https://readdy.ai/api/search-image?query=PVC%20window%20lock%20mechanism%20repair%20in%20Biganos%20house%2C%20close%20up%20of%20security%20system%20installation%2C%20professional%20hands%2C%20detailed%20work&width=800&height=500&seq=blog28&orientation=landscape',
    date: '19 Décembre 2024',
    readTime: '10 min',
    category: 'Service Complet'
  },
  {
    slug: 'reparation-fenetre-mios',
    city: 'Mios',
    title: 'Réparation de Fenêtres à Mios',
    excerpt: 'Réparation professionnelle de fenêtres et baies vitrées à Mios. Devis gratuit.',
    image: 'https://readdy.ai/api/search-image?query=aluminum%20bay%20window%20adjustment%20in%20Mios%20residence%2C%20technician%20using%20level%20tool%2C%20precise%20alignment%2C%20professional%20installation&width=800&height=500&seq=blog29&orientation=landscape',
    date: '18 Décembre 2024',
    readTime: '11 min',
    category: 'Pro'
  },
  {
    slug: 'reparation-fenetre-salles',
    city: 'Salles',
    title: 'Réparation de Fenêtres à Salles',
    excerpt: 'Spécialiste de la réparation de fenêtres PVC, bois, aluminium à Salles.',
    image: 'https://readdy.ai/api/search-image?query=wooden%20window%20frame%20restoration%20in%20rural%20Salles%20house%2C%20craftsman%20working%20with%20natural%20materials%2C%20traditional%20techniques%2C%20artisan%20quality&width=800&height=500&seq=blog30&orientation=landscape',
    date: '17 Décembre 2024',
    readTime: '10 min',
    category: 'Spécialiste'
  }
];

export default function Blog() {
  useEffect(() => {
    document.title = "Blog Réparation Fenêtres | Guides & Conseils Experts | Bordeaux Gironde";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Découvrez nos guides complets sur la réparation de fenêtres PVC, bois, aluminium, baies vitrées et volets roulants. Conseils d\'experts pour Bordeaux et toute la Gironde.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'blog réparation fenêtres, guide fenêtres, conseils fenêtres, réparation PVC, réparation bois, réparation aluminium');
    }

    // Open Graph tags
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement('meta');
      ogType.setAttribute('property', 'og:type');
      document.head.appendChild(ogType);
    }
    ogType.setAttribute('content', 'website');

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', 'https://reparation-fenetre-bordeaux.fr/blog');

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'Blog Réparation Fenêtres | Guides & Conseils Experts | Bordeaux Gironde');

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', 'Découvrez nos guides complets sur la réparation de fenêtres PVC, bois, aluminium, baies vitrées et volets roulants. Conseils d\'experts pour Bordeaux et toute la Gironde.');

    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute('content', 'https://readdy.ai/api/search-image?query=collection%20of%20professional%20window%20repair%20guides%20and%20articles%20displayed%20on%20modern%20digital%20interface%2C%20featuring%20various%20window%20types%20PVC%20wood%20aluminum%20bay%20windows%20and%20roller%20shutters%2C%20educational%20content%20layout%20with%20expert%20tips%20and%20advice%2C%20clean%20professional%20design%20with%20tools%20and%20materials%20visible%20in%20background&width=1200&height=630&seq=ogblog1&orientation=landscape');

    let ogImageWidth = document.querySelector('meta[property="og:image:width"]');
    if (!ogImageWidth) {
      ogImageWidth = document.createElement('meta');
      ogImageWidth.setAttribute('property', 'og:image:width');
      document.head.appendChild(ogImageWidth);
    }
    ogImageWidth.setAttribute('content', '1200');

    let ogImageHeight = document.querySelector('meta[property="og:image:height"]');
    if (!ogImageHeight) {
      ogImageHeight = document.createElement('meta');
      ogImageHeight.setAttribute('property', 'og:image:height');
      document.head.appendChild(ogImageHeight);
    }
    ogImageHeight.setAttribute('content', '630');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-teal/5 via-white to-orange/5">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <div className="inline-block bg-teal/10 text-teal px-6 py-2 rounded-full text-sm font-semibold mb-6">
              BLOG EXPERT
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Guides & Conseils<br />Réparation de Fenêtres
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Découvrez nos guides complets sur la réparation de fenêtres PVC, bois, aluminium, baies vitrées et volets roulants dans toute la Gironde
            </p>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16"
          >
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl font-bold text-teal mb-2">30+</div>
              <div className="text-sm text-gray-600">Articles Experts</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl font-bold text-teal mb-2">15+</div>
              <div className="text-sm text-gray-600">Ans d'Expérience</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl font-bold text-teal mb-2">5000+</div>
              <div className="text-sm text-gray-600">Réparations</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl font-bold text-teal mb-2">98%</div>
              <div className="text-sm text-gray-600">Clients Satisfaits</div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogArticles.map((article, index) => (
              <motion.article
                key={article.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <Link 
                  to={`/blog/${article.slug}`}
                  className="group block bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-teal"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img 
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-teal text-white px-4 py-1 rounded-full text-xs font-semibold">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                      <div className="flex items-center gap-1">
                        <i className="ri-map-pin-line text-teal"></i>
                        <span>{article.city}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-time-line text-teal"></i>
                        <span>{article.readTime}</span>
                      </div>
                    </div>
                    <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal transition-colors">
                      {article.title}
                    </h2>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-500">{article.date}</span>
                      <span className="text-teal font-semibold text-sm flex items-center gap-2 group-hover:gap-3 transition-all whitespace-nowrap">
                        Lire l'article
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal to-teal/90">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Besoin d'une Réparation ?
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Contactez-nous pour un devis gratuit et une intervention rapide dans toute la Gironde
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/33756886967"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 bg-white text-teal px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                Diagnostic WhatsApp Gratuit
              </a>
              <Link
                to="/#contact"
                className="inline-flex items-center justify-center gap-3 bg-orange text-white px-8 py-4 rounded-full font-semibold hover:bg-orange/90 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-2xl"></i>
                Nous Contacter
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
